import { useNavigate } from '@tanstack/react-router'

import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { useToast } from '@/hooks'
import { type Document, useDocumentsMutations } from '@/modules/documents'
import { useFolder } from '@/modules/folders'
import { useDialogActions, useDialogData, useDialogIsOpen } from '@/stores'
import { getFolderPath } from '@/utils'

const dialogId = 'delete-documents'

export const DeleteDocumentsDialog = () => {
  const navigate = useNavigate()
  const { successToast, errorToast } = useToast()
  const open = useDialogIsOpen(dialogId)
  const toDelete = (useDialogData() as Document[] | undefined) || []
  const { closeDialog } = useDialogActions()
  const total = toDelete?.length || 0
  const document = total === 1 ? toDelete[0] : null
  const label = document ? 'Document' : 'Documents'

  const folder = useFolder()

  const { deleteDocuments } = useDocumentsMutations()
  const handleSubmit = () => {
    deleteDocuments(toDelete)
      .then(() => successToast(`${label} deleted successfully`))
      .catch((error) => errorToast('Failed to delete documents', error))
    closeDialog(true)

    console.log('folder', folder)
    const folderToRedirect = folder || toDelete[0].folder
    navigate({
      to: folderToRedirect ? getFolderPath(folderToRedirect) : '/documents',
    })
  }

  return (
    <Dialog open={open} onOpenChange={(open) => !open && closeDialog()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete {label}?</DialogTitle>
          <DialogDescription>
            This will permanently delete{' '}
            {document ? `"${document.fileName}"` : `${total} documents`}. This
            action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2 pt-4">
          <Button theme="outline" onClick={() => closeDialog()}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} theme="danger">
            Delete {label}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

DeleteDocumentsDialog.id = dialogId
